import { SvgIcon, SvgIconProps } from './SvgIcon';

export const ArrowRightIcon = (props: SvgIconProps): JSX.Element => {
  const { viewBox, ...rest } = props;

  return (
    <SvgIcon {...rest} viewBox={viewBox ?? '0 0 20 20'}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5017 4.93945C11.8113 4.66426 12.2854 4.69215 12.5606 5.00174L16.5606 9.50174C16.8131 9.7859 16.8131 10.2141 16.5606 10.4983L12.5606 14.9983C12.2854 15.3079 11.8113 15.3358 11.5017 15.0606C11.1921 14.7854 11.1643 14.3113 11.4394 14.0017L14.3299 10.75L3.5 10.75C3.08579 10.75 2.75 10.4142 2.75 10C2.75 9.58579 3.08579 9.25001 3.5 9.25001L14.3299 9.25001L11.4394 5.99828C11.1643 5.68869 11.1921 5.21464 11.5017 4.93945Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
